import { FC } from "react";

export type FormProps = {
  className?: string;
  submitOnEnter?: boolean;
  onSubmit?: () => void;
  children?: React.ReactNode;
};

const Form: FC<FormProps> = ({ onSubmit, submitOnEnter, className, children }) => {
  return (
    <form
      noValidate
      className={className}
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit?.();
      }}
    >
      {children}
      {submitOnEnter && <input style={{ display: "none" }} type="submit" />}
    </form>
  );
};

export default Form;
